export const ExtensionFile = {
  ZIP: "ZIP",
  PDF: "PDF",
};
